import SpecialPromo from "@/assets/svg/SpecialPromo";
import FreeTag from "./FreeTag";
import { useTranslation } from "react-i18next";

const SignupFreeSpecialPromo = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full bg-[#7B9E7E0D] rounded-lg flex flex-col justify-center items-center my-4">
      <div className="w-full  border-b-[0.5px] border-[#90B393] p-2 flex  justify-center items-center">
        <SpecialPromo />
        <p className="font-sans">{t("signUp.specialPromo")}</p>
      </div>
      <div className="w-full p-2  flex gap-2  justify-center items-center">
        <FreeTag
          key="freeListing"
          parentClass="flex justify-center items-center rounded-md border !border-[#7B9E7E] !bg-[#7B9E7E0D] p-1 gap-1"
          textClass="!text-[#32493B] text-[12px] font-sans "
          fillIcon="#32493B"
          label={t("signUp.freeListing")}
        />

        <FreeTag
          key="freeAiQueries"
          parentClass="flex justify-center items-center rounded-md border !border-[#F94C863D] !bg-[#F94C860A] p-1 gap-1"
          textClass="!text-[#EC3C77] text-[12px] font-sans"
          fillIcon="#EC3C77"
          label={t("signUp.freeAiQueries")}
        />
      </div>
    </div>
  );
};

export default SignupFreeSpecialPromo;
